export default __webpack_public_path__ + "static/media/g1.11703eb3.jpg";